<!-- <div style="text-align: right;" *ngIf="WriteCompliance">
    <button mat-raised-button color="primary" [disabled]="!studentOfficialVisitFormGroup.valid" (click)="onSubmit()">
        <mat-icon>save</mat-icon> {{this.studentOfficialVisit && this.studentOfficialVisit.studentOfficialVisitId
        !==
        null ?
        'Update': 'Save'}}
    </button>
    &nbsp;
    <button mat-raised-button>
        Cancel
    </button>
</div> -->
<br />

<div class="row form-group" [ngClass]="{disabledDiv: !WriteCompliance}">
    <div class="col-sm-6">
        <div class="row form-group">
            <div [formGroup]="studentOfficialVisitFormGroup" class="col-sm-12">
                <mat-form-field [hidden]="true">
                    <input matInput formControlName="studentId">
                </mat-form-field>
                <mat-form-field [hidden]="true">
                    <input matInput formControlName="studentOfficialVisitId">
                </mat-form-field>
                <mat-form-field [hidden]="true">
                    <input matInput formControlName="tenantId">
                </mat-form-field>
                <div class="row form-group">
                    <!-- <div class="col-sm-3">
                        <mat-form-field style="display:flex;flex-direction: column">
                            <mat-label>High School</mat-label>
                            <input matInput [disabled]="true" placeholder="High School"
                                value="{{studentOfficialVisit.highSchoolDescription}}">
                        </mat-form-field>               
                    </div> -->
                    <div class="col-sm-4">
                        <mat-form-field style="display:flex;flex-direction: column" dateFormat1>
                            <mat-label>Transcript Received Date</mat-label>
                            <input matInput required formControlName="transcriptRecievedDate" [matDatepicker]="picker1">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker touchUi #picker1></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                        <mat-form-field style="display:flex;flex-direction: column">
                            <mat-label>Registered with NCAA</mat-label>
                            <input matInput [disabled]="true" placeholder="Registered with NCAA"
                                value="{{NcaaId}}">
                        </mat-form-field>
                    </div>
                    <!-- <div class="col-sm-3">
                        <mat-checkbox formControlName="isOfficialTranscript" style="margin-top: 19px;width: 50%;">Official
                            Transcript
                        </mat-checkbox>
                    </div> -->
                
                <!-- <div class="row form-group">
                    <div class="col-sm-3">
                        <mat-form-field style="display:flex;flex-direction: column;">
                            <mat-label>Letter Date</mat-label>
                            <input matInput [disabled]="true" placeholder="Letter Date"
                                value="{{studentOfficialVisit.letterPrintDate | date:'MM/dd/yyyy'}}">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field style="display:flex;flex-direction: column">
                            <mat-label>Letter Status</mat-label>
                            <mat-select required formControlName="letterStatusId">
                                <mat-option>--Select--</mat-option>
                                <mat-option *ngFor="let item of letterStatusList" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div> -->
                    <div class="col-sm-4" style="text-align: right;" *ngIf="WriteCompliance">
                        <button mat-raised-button color="primary" [disabled]="!studentOfficialVisitFormGroup.valid" (click)="onSubmit()">
                            <mat-icon>save</mat-icon> {{this.studentOfficialVisit && this.studentOfficialVisit.studentOfficialVisitId
                            !==
                            null ?
                            'Update': 'Save'}}
                        </button>
                        &nbsp;
                        <button mat-raised-button>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" [ngClass]="{disabledDiv: !WriteCompliance && studentOfficialVisit.studentOfficialVisitId}">
                <div class="row form-group">
                    <div class="col-sm-4" *ngIf="WriteCompliance && studentOfficialVisit.studentOfficialVisitId">
                        <mat-form-field style="display:flex;flex-direction: column" dateFormat1>
                            <mat-label>Official Visit Date</mat-label>
                            <input matInput [(ngModel)]="studentOfficialVisitOccurence.occurenceDate" required
                                [matDatepicker]="picker2">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker touchUi #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-4" *ngIf="WriteCompliance && studentOfficialVisit.studentOfficialVisitId">
                        <mat-form-field style="display:flex;flex-direction: column">
                            <mat-label>Reason</mat-label>
                            <mat-select required [(ngModel)]="studentOfficialVisitOccurence.occurenceReasonId">
                                <mat-option>--Select--</mat-option>                              
                                <ng-container *ngFor="let item of officialVisitReasonList">
                                    <mat-option *ngIf="evalBind(item,studentOfficialVisitOccurence.occurenceReasonId)" [value]="item.id">
                                        {{item.description}}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-4" style="text-align: right;" *ngIf="WriteCompliance && studentOfficialVisit.studentOfficialVisitId">
                        <button mat-raised-button (click)="add()" color="primary" [disabled]="studentOfficialVisitOccurence.occurenceReasonId == null || studentOfficialVisitOccurence.occurenceDate == null">
                            {{this.studentOfficialVisitOccurence && this.studentOfficialVisitOccurence.studentOfficialVisitOccurenceId
                                !==
                                null ?
                                'Update': 'Add'}}
                        </button>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-12">
                        <table mat-table matSort [dataSource]="dataSource" style="width: 100%;">
                            <ng-container matColumnDef="OfficialVisitDate">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Official Visit Date </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.occurenceDate | date:'MM/dd/yyyy'}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Reason">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef> Reason </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.occurenceReason}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="action" stickyEnd>
                                <th mat-header-cell *matHeaderCellDef> Actions </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button [matMenuTriggerFor]="menu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button (click)="edit(element)" mat-menu-item>
                                            Edit
                                        </button>
                                        <button (click)="delete(element.studentOfficialVisitOccurenceId)" mat-menu-item>
                                            Delete
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="row form-group">
            <div class="col-sm-12" [ngClass]="{disabledDiv: !WriteCompliance}">
                <div [formGroup]="studentHighSchoolFormGroup" *ngIf="WriteCompliance">
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="studentId">
                    </mat-form-field>
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="studentHighSchoolId">
                    </mat-form-field>
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="tenantId">
                    </mat-form-field>
                    <div class="row form-group">
                        <div class="col-sm-3" style="text-align: right; place-self: flex-end;">
                            <mat-checkbox formControlName="isCurrent" >Current High School
                            </mat-checkbox>
                        </div>
                
                        <div class="col-sm-7">
                            <mat-form-field [hidden]="true">
                                <input matInput formControlName="highSchoolInstitutionId">
                            </mat-form-field>
                            <div *ngIf="this.studentHighSchool.highSchoolInstitutionId != null; else elseBlock">
                                <span>High School</span><br />
                                <span><strong>{{this.studentHighSchool.institutionDescription}}</strong></span>
                            </div>
                            <ng-template #elseBlock>
                                <mat-form-field style="display:flex;flex-direction: column;">
                                    <mat-label>High School</mat-label>
                                    <input required matInput (focus)="openDialog()" formControlName="institutionDescription"
                                        placeholder="Institution">
                                </mat-form-field>
                            </ng-template>
                        </div>
                        <div class="col-sm-2" style="text-align: right;" >
                            <button mat-raised-button color="primary" (click)="openDialog()" *ngIf="WriteCompliance">
                                <mat-icon>{{this.studentHighSchool.highSchoolInstitutionId != null ? 'edit':'search'}}
                                </mat-icon> {{this.studentHighSchool.highSchoolInstitutionId != null ? 'Edit':'Search'}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row form-group" *ngIf="WriteCompliance">
                    <div class="col-sm-12" style="text-align: right;">
                        <button mat-raised-button color="primary" (click)="onSubmitHighSchool()" [disabled]="this.studentHighSchool.institutionDescription == null">
                            {{this.studentHighSchool && this.studentHighSchool.studentHighSchoolId
                                !==
                                null ?
                                'Update': 'Add'}}
                        </button>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-12" [ngStyle]="{'padding-top': !WriteCompliance ? '89px' : '20px'}">
                        <table mat-table matSort [dataSource]="highSchoolDataSource" style="width: 100%;">
                            <ng-container matColumnDef="institutionCode">
                                <th mat-header-cell *matHeaderCellDef> High School Code </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.institutionCode}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="institutionDescription">
                                <th mat-header-cell *matHeaderCellDef> High School Description </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.institutionDescription}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="isCurrent">
                                <th mat-header-cell *matHeaderCellDef> Current </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.isCurrent? 'Yes' : 'No'}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="action" stickyEnd>
                                <th mat-header-cell *matHeaderCellDef> Actions </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button [matMenuTriggerFor]="menu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button (click)="editHighSchool(element.studentHighSchoolId)" mat-menu-item>
                                            Edit
                                        </button>
                                        <button (click)="deleteHighSchool(element.studentHighSchoolId)" mat-menu-item>
                                            Delete
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="highSchoolDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: highSchoolDisplayedColumns;"></tr>
                        </table>
                        <mat-paginator #highSchoolPaginator="matPaginator" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>